import { Button } from 'baseui/button';
import { Check } from 'baseui/icon';
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from 'baseui/modal';
import { useSnackbar } from 'baseui/snackbar';
import { useState, useEffect } from 'react'
import { useDeletePropertyMappingMutation } from '../../../services/mapping/bacnet';
import { Notification } from 'baseui/notification';
import { IoTrashOutline } from 'react-icons/io5';
import { AccessRoles, useHasRole } from '../../../hooks/useHasRole';

export const DeletePropertyMappingButton = ({ mappingId, name }: any) => {
    const hasAccessMappingDelete = useHasRole(AccessRoles.Mapping.Delete);
    const { enqueue } = useSnackbar();

    const [isOpen, setIsOpen] = useState(false);
    const [deleteObject, deleteObjectResult] = useDeletePropertyMappingMutation();
    const onDeleteObjectClick = (e: any) => { deleteObject(mappingId); }


    useEffect(() => {
        if (deleteObjectResult?.isSuccess) {
            enqueue({
                message: 'sucessfully deleted',
                startEnhancer: ({ size }) => <Check size={size} />,
            });
            setIsOpen(false);
        }
    }, [deleteObjectResult]);

    return (
        <>
            <Button disabled={!hasAccessMappingDelete} size="compact" kind="secondary" shape="pill" onClick={() => setIsOpen(true)} isLoading={deleteObjectResult.isLoading}> <IoTrashOutline /></Button>
            <Modal closeable onClose={() => setIsOpen(false)} isOpen={isOpen}>
                <ModalHeader>Delete Mapping</ModalHeader>
                <ModalBody>
                    {deleteObjectResult.error &&
                        <Notification kind='negative'>
                            There has been an error loading data: {JSON.stringify(deleteObjectResult.error)}
                        </Notification>
                    }
                    Do you really want to delete '{name}'?
                </ModalBody>
                <ModalFooter>
                    <ModalButton kind="tertiary" onClick={() => setIsOpen(false)}>
                        Cancel
                    </ModalButton>
                    <ModalButton onClick={onDeleteObjectClick} isLoading={deleteObjectResult.isLoading}>Okay</ModalButton>
                </ModalFooter>
            </Modal>
        </>
    );
}